import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ReportFiltersListComponent from './ReportFiltersListComponent';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import Details from '@mui/icons-material/PlaylistAdd';

const ReportFiltersListCard = ({
  reportFilters,
  onAdd,
  onPropertyChanged,
  onExpandedChanged,
  onSave,
  onDelete,
  dictionaryEditorTypes,
  validation
}) => {
  const [t] = useTranslation();

  return (
    <Card
      icon={Details}
      iconColor='primary'
      title={t('Reports.ReportFilters.Title')}
      actions={<IconButton color='transparent' type='add' fontSize='medium' tooltip={t('Tooltips.Add')} onClick={onAdd} />}
    >
      <ReportFiltersListComponent
        reportFilters={reportFilters}
        onPropertyChanged={onPropertyChanged}
        onExpandedChanged={onExpandedChanged}
        onSave={onSave}
        onDelete={onDelete}
        dictionaryEditorTypes={dictionaryEditorTypes}
        validation={validation}
      />
    </Card>
  );
};

ReportFiltersListCard.propTypes = {
  reportFilters: PropTypes.array.isRequired,
  dictionaryEditorTypes: PropTypes.array,
  onAdd: PropTypes.func.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  onExpandedChanged: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  validation: PropTypes.object
};

export default ReportFiltersListCard;
